/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import GaugeChart from 'react-gauge-chart';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

type PropsType = {
  header: string,
  currencySign: string,
  chart1: {
    title: string,
    value: number,
    total: number
  },
  chart2: {
    title: string,
    value: number,
    total: number
  }
};

class EventPageDetailStatsGuageCard extends React.Component<PropsType> {
  static contextType = DefaultContainerContext;

  render(): React.Element<'div'> {
    const { chart1, chart2, header, currencySign } = this.props;
    const GaugeChartConfig = {
      nrOfLevels: 5,
      arcWidth: 0.25,
      cornerRadius: 5,
      hideText: true,
      marginInPercent: 0.02
    };

    return (
      <div className="panel panel-default panel-chart">
        <div className="panel-heading">{header}</div>

        <div className="panel-body no-padding" style={{ padding: '0 15px' }}>
          <div className="row" style={{ minHeight: '300px' }}>
            {/* Chart column start */}
            <div className="gauge col-sm-6 no-padding">
              <div
                className="highcharts-container"
                style={{
                  height: '180px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <GaugeChart id={`gauge-chart${_.random(0, 1000)}`}
                  {...GaugeChartConfig}
                  colors={['#16aff1', '#8893dd']}
                  percent={chart1.value / chart1.total}
                  style={{ maxWidth: '250px', width: '100%' }}
                />
              </div>


              <h3>{chart1.title}</h3>

              <div className="row percent-style">
                <span>{chart1.value}</span>
              </div>
            </div>
            {/* Chart column end */}

            {/* Chart column start */}
            <div className="gauge col-sm-6 no-padding">
              <div
                className="highcharts-container"
                style={{
                  height: '180px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <GaugeChart id={`gauge-chart${_.random(0, 1000)}`}
                  {...GaugeChartConfig}
                  colors={['#ffcb93', '#efae82']}
                  percent={chart2.value / chart2.total}
                  style={{ maxWidth: '250px', width: '100%' }}
                />
              </div>


              <h3>{chart2.title}</h3>

              <div className="row percent-style">
                <span>{currencySign}{Math.round(chart2.value)}</span>
              </div>
            </div>
            {/* Chart column end */}
          </div>
        </div>
      </div>
    );
  }
}

export default EventPageDetailStatsGuageCard;
